// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'

import PropagateLoader from 'qualabs-react-spinners/PropagateLoader'

import './index.css'

class ComponentSpinner extends Component {

  render () {
    return (
      this.props.spinner.showComponentSpinner &&
      <div className='row component-spinner'>
        <div className='container col-4 col-offset-4 col-md-4 col-md-offset-4'>
          <div className='row spinner-content'>
            <div className='col-12 col-sm-12 col-md-6  spinner-text'>
              <span>{this.props.spinner.componentSpinnerText || 'Updating data'}</span>
            </div>
            <div className='col-12 col-sm-12 col-md-6 spinner-dot'>
              <PropagateLoader
                color={'#E8308A'}
                size={'2vh'}
                distance={this.props.distance}
                css={`
                width:100%;
                height:100%;`
                }
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps ({spinner}) {
  return {spinner}
}

export default connect(mapStateToProps, {})(ComponentSpinner)
